export default __webpack_public_path__ + "static/media/Blog_Background.1cd33f4d.jpg";